<template>
    <div>
        <v-container fluid fill-height v-if="!authenticated">
            <v-layout align-center justify-center>
                <v-flex xs12 sm6 md2>
                    <v-card class="elevation-12">
                        <v-toolbar dark >
                            <span class="mx-auto">Checando Sesión...</span>
                        </v-toolbar>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container grid-list-md v-else>
            <v-layout row wrap>
                <v-flex xs12>
                    <h1>Inicio</h1>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'inicio',
    props: ['authenticated'],
    methods: {
      ...mapActions(['cambiarTitulo']),
    },
    mounted () {
      this.cambiarTitulo('Inicio')
    }
  }
</script>